import { Result } from "@/shared/feedback/result";
import { useTranslations } from "use-intl";
import { SignStatusIcon } from "@/modules/signing/shared/ui/sign-status-icon/sign-status-icon";
import { QrcodeOutlined } from "@ant-design/icons";
import { usePalette } from "@/shared/theme";
import Text from "@/shared/typography/text";

export function StatusQrOpened() {
  const t = useTranslations("Common");
  const palette = usePalette();

  return (
    <Result
      icon={
        <div className={"flex justify-center"}>
          <SignStatusIcon
            icon={<QrcodeOutlined />}
            iconColor={palette.accent[7]}
            iconBackgroundColor={palette.accent[1]}
            iconSecondaryBackgroundColor={palette.accent[0]}
          />
        </div>
      }
      status={"info"}
      title={
        <Text as={"span"} medium type={"headline1"}>
          {t("SIGN_STATUS_QR_CODE_OPENED_TITLE")}
        </Text>
      }
    />
  );
}
